module.exports = __webpack_public_path__ + "img/searchIcon.2c449603.svg";